// src/js/components/Evaluation/Results.js
import React, { Component } from "react";
import renderHTML from "react-render-html";

class BenchmarkBarElement extends Component {
    render() {
        // console.log(this.props);
        let displaytext = this.props.width + '%';
        let titletext = this.props.width + '%';
        if (this.props.width === 0) {
            displaytext = "";
        } else if (this.props.width < 5) {
            displaytext = "&nbsp;";
        }
        return(
            <div className={`evBenchmarkBar ${this.props.bartype}`} style={{width: `${this.props.width}%`}} title={titletext}>{renderHTML(displaytext)}</div>
        )
    }
}

export default BenchmarkBarElement;